// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2BT1u","balanceDisclaimer":"posDashboard_balanceDisclaimer__3cTEh"};